import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

// Impressum gemaess TMG (DDG) §5 und MStV §18 Abs. 1. Pflicht
// auf jeder gewerblichen oder geschaeftsmaessigen Webseite in DE.
// Betreiber: hobeco UG (haftungsbeschränkt), HRB 127985 (AG Köln).
const ImpressumPage = () => {
  return (
    <div className="min-h-screen">
      <div className="max-w-3xl mx-auto px-4 py-12">
        <Link to="/" className="inline-flex items-center gap-1 text-sm text-emerald-600 hover:text-emerald-700 mb-8 dark:text-emerald-400">
          <ArrowLeft size={16} /> Zurück zur Startseite
        </Link>

        <h1 className="text-3xl font-bold text-gray-900 mb-2 dark:text-gray-100">Impressum</h1>
        <p className="text-sm text-gray-500 mb-8 dark:text-gray-400">Angaben gemäß §5 DDG (ehemals TMG) und §18 Abs. 1 MStV</p>

        <div className="prose prose-gray max-w-none space-y-6 text-gray-700 text-[15px] leading-relaxed dark:text-gray-300">
          <section>
            <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3 dark:text-gray-100">Diensteanbieter</h2>
            <p>
              hobeco UG (haftungsbeschränkt)<br />
              Betreiber der Plattform „PredFuture"<br />
              Am Ackerrain 14<br />
              50933 Köln<br />
              Deutschland
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3 dark:text-gray-100">Vertreten durch</h2>
            <p>Jörg Lorbach, Geschäftsführer</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3 dark:text-gray-100">Kontakt</h2>
            <p>
              E-Mail: <a href="mailto:dev@hobeco.one" className="text-emerald-600 hover:underline dark:text-emerald-400">dev@hobeco.one</a>
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3 dark:text-gray-100">Registereintrag</h2>
            <p>
              Registergericht: Amtsgericht Köln<br />
              Registernummer: HRB 127985
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3 dark:text-gray-100">Verantwortlich für den Inhalt nach §18 Abs. 2 MStV</h2>
            <p>
              Jörg Lorbach<br />
              Am Ackerrain 14, 50933 Köln
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3 dark:text-gray-100">Haftung für Inhalte</h2>
            <p>
              Als Diensteanbieter sind wir gemäß §7 Abs. 1 DDG für eigene Inhalte
              auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach
              §§8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht verpflichtet,
              übermittelte oder gespeicherte fremde Informationen zu überwachen oder
              nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
              hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
              Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3 dark:text-gray-100">Haftung für Links</h2>
            <p>
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren
              Inhalte wir keinen Einfluss haben. Deshalb können wir für diese
              fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
              verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber
              der Seiten verantwortlich.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3 dark:text-gray-100">Hinweis zur Plattform-Natur</h2>
            <p>
              PredFuture läuft aktuell als kostenloses Showcase. Es werden ausschließlich
              virtuelle Credits ohne Geldwert eingesetzt. Es findet kein Glücksspiel im
              Sinne des Glücksspielstaatsvertrags (GlüStV) statt – Wetten sind kostenfrei
              und Auszahlungen erfolgen nicht in Geld oder geldwerten Leistungen.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3 dark:text-gray-100">EU-Streitschlichtung</h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung
              (OS) bereit: <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-emerald-600 hover:underline dark:text-emerald-400">https://ec.europa.eu/consumers/odr/</a>.<br />
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor
              einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>
        </div>

        <p className="text-xs text-gray-400 mt-12 dark:text-gray-500">Stand: Juni 2026 · hobeco UG (haftungsbeschränkt)</p>
      </div>
    </div>
  );
};

export default ImpressumPage;
